exports.getSignedURLforDownloadAttachment = getSignedURLforDownloadAttachment;
exports.changeDownloadState = changeDownloadState;
exports.getDownloadAttachmentStates = getDownloadAttachmentStates;
const helper =  require('../common/helper');

let globals = {
    apiGatewayUrl: '/notifications/apigateway/'
}

let downloadAttachmentStates = {};

async function getSignedURLforDownloadAttachment(spaceId, classId, announcementforeignId, attachment) {
  try {
    const fileType = attachment.file_name.split('.').pop(); // get the file extension
    const mimeType = getMimeType(fileType); // determine the MIME type based on the file extension
    const request = {
      method: 'GET',
      url: `${globals.apiGatewayUrl}signedURLforDownloadAttachment/${spaceId}/${classId}/announcement/${announcementforeignId}/attachment/${attachment['doc-id']}/${attachment.file_name}`,
      headers: {
        "Content-Type": mimeType // set the content type based on the file type
      }
    };
    downloadAttachmentStates[attachment['doc-id']] =  true;
    const response = await helper.makeRequest(request);
    return JSON.parse(response);
  } catch (error) {
    //redirect to dashboard in case of error
    window.location.href = window.location.origin;
    throw error;
  }
}

function getDownloadAttachmentStates(){
  return downloadAttachmentStates;
}

function changeDownloadState(attachmentData){
  downloadAttachmentStates[attachmentData['doc-id']] =  false;
}

function getMimeType(fileType) {
  switch (fileType.toLowerCase()) {
    case 'doc':
    case 'docx':
      return 'application/msword';
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'png':
      return 'image/png';
    case 'ppt':
    case 'pptx':
    case 'pps':
      return 'application/vnd.ms-powerpoint';
    case 'pdf':
      return 'application/pdf';
    case 'xls':
    case 'xlsx':
      return 'application/vnd.ms-excel';
    default:
      return 'application/octet-stream';
  }
}
  